import { render } from "./DropMenu.vue?vue&type=template&id=b152599c&scoped=true"
import script from "./DropMenu.vue?vue&type=script&lang=js"
export * from "./DropMenu.vue?vue&type=script&lang=js"

import "./DropMenu.vue?vue&type=style&index=0&id=b152599c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b152599c"

export default script